import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Columns3 } from 'lucide-react';
import { validatePermission } from 'actions';
import Button from 'v3/components/Button';
import { canReadKanban, KANBAN_PATH } from './contract';

export default function KanbanEntryButton() {
  const location = useLocation();
  const navigate = useNavigate();
  if (!canReadKanban(validatePermission)) return null;
  return (
    <Button
      variant="secondary"
      id="button-kanban-cargas"
      onClick={() =>
        navigate(KANBAN_PATH, {
          state: { kanbanOrigin: { path: location.pathname, search: location.search } },
        })
      }
      style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginRight: 10 }}
    >
      <Columns3 size={16} aria-hidden="true" /> Kanban de cargas
    </Button>
  );
}
